import { l } from 'ui/lib/lodashImports'

export function stripErrorCode(string: string): string {
	if (string && !l.isNaN(Number(string.substring(0, 2))) && string[3] === ':') {
		return string.substring(4)
	} else {
		return string
	}
}
